import React from 'react';
import { injectIntl } from 'react-intl';
import { Form } from '@ant-design/compatible';
import { Radio } from 'antd';
import PropTypes from 'prop-types';
import { getJobMessages } from '../../../../constants/messages';
import ChargeType from '../CommonComponents/ChargeType';
import DefaultForm from './DefaultForm';

const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

let jobMessages = getJobMessages();

const messages = {
	...jobMessages,
};

class Installation extends React.Component {
	getIntl = (str) => this.props.intl.formatMessage({ ...messages[str] });

	renderDefaultForm = () => {
		const { form, saveFields, getField, isUpdate } = this.props;
		return <DefaultForm form={form} saveFields={saveFields} getField={getField} isUpdate={isUpdate} />;
	};

	renderChargeOption = () => {
		const { props, getIntl } = this;
		const { form, saveFields, getField } = props;
		const save = (chargeType) => {
			const invoiceInfo = getField('invoiceInfo');
			saveFields({ invoiceInfo: { ...invoiceInfo, chargeType } });
		};
		const chargeType = getField('invoiceInfo.chargeType');
		const options = [
			<RadioButton key={1} value={1}>
				{getIntl('bought')}
			</RadioButton>,
			<RadioButton key={2} value={2}>
				{getIntl('leased')}
			</RadioButton>,
		];
		return <ChargeType form={form} chargeType={chargeType} onChange={save} options={options} />;
	};

	renderCharge = () => {
		const {
			props: { form, getField },
			getIntl,
		} = this;
		const { getFieldDecorator } = form;
		let chargeType = getField('invoiceInfo.chargeType');
		const options = [
			<RadioButton key={0} value={false}>
				{getIntl('no')}
			</RadioButton>,
			<RadioButton key={1} value={true}>
				{getIntl('yes')}
			</RadioButton>,
		];
		if (chargeType)
			return (
				<FormItem label={getIntl('beChargedInstallation')}>
					{getFieldDecorator('beCharged', {
						initialValue: true,
						rules: [
							{
								required: true,
								message: getIntl('beChargedError'),
							},
						],
					})(<RadioGroup defaultValue={true}>{options}</RadioGroup>)}
				</FormItem>
			);
	};

	fullRender = () => {
		const { renderDefaultForm, renderChargeOption, renderCharge } = this;
		return (
			<div>
				{renderDefaultForm()}
				{renderChargeOption()}
				{renderCharge()}
			</div>
		);
	};

	render() {
		return this.fullRender();
	}
}

Installation.propTypes = {
	intl: PropTypes.object.isRequired,
	form: PropTypes.object.isRequired,
	saveFields: PropTypes.func.isRequired,
	getField: PropTypes.func.isRequired,
	isUpdate: PropTypes.bool.isRequired,
};

export default injectIntl(Installation);
